module.exports = __webpack_public_path__ + "img/levelup-logo-accestance-dark.9e8374dd.svg";